export const strapiApiEndPoints = {
  // Components with media: apple_store_icon, google_play_icon, tick_mark_img
  signInRegister:
    "/api/singin-register" +
    "?populate[apple_store_icon][populate][0]=img" +
    "&populate[apple_store_icon][populate][1]=arabic_img" +
    "&populate[google_play_icon][populate][0]=img" +
    "&populate[google_play_icon][populate][1]=arabic_img" +
    "&populate[tick_mark_img][populate][0]=img" +
    "&populate[tick_mark_img][populate][1]=arabic_img",

  // Each of these is a component that has an `icon` component with img / arabic_img media
  commonApiData:
    "/api/common-data" +
    "?populate[settings_t_and_conditions][populate][link]=*" +
    "&populate[settings_t_and_conditions][populate][icon][populate]=*" +
    "&populate[settings_privacy_and_security][populate][link]=*" +
    "&populate[settings_privacy_and_security][populate][icon][populate]=*" +
    "&populate[settings_fees_and_charges][populate][link]=*" +
    "&populate[settings_fees_and_charges][populate][icon][populate]=*",

  // banner & mobileBanner are components with img / arabic_img inside
  offersData:
    "/api/offer" +
    "?populate[banner][populate][0]=img" +
    "&populate[banner][populate][1]=arabic_img" +
    "&populate[mobileBanner][populate][0]=img" +
    "&populate[mobileBanner][populate][1]=arabic_img",

  // Already confirmed working pattern
  policiesBg:
    "/api/policy-card-bgs" +
    "?populate[card_bg_image][populate][0]=img" +
    "&populate[card_bg_image][populate][1]=arabic_img" +
    "&pagination[limit]=100",

  // Still fine with wildcard
  newPoliciesStaticData: "/api/new-policy?populate=*",

  // plans has image (media) + benefits (component/relation), headings_content is component
  buyOnlinePlans:
    "/api/buy-online-plan" +
    "?populate[plans][populate][0]=image" +
    "&populate[plans][populate][1]=benefits" +
    "&populate[headings_content]=*",

  buyOnlineQuestionniare: "/api/buy-online-questionnaire?populate=*",

  // No populate needed/used before – leave as is
  lifeFunds: "/api/fund-lists",
  faqs:
    "/api/c-p-faq-categories" +
    "?populate[title]=true" +
    "&populate[c_p_faqs][populate][question]=true" +
    "&populate[c_p_faqs][populate][answer]=true",

  fundManagement: "/api/fund-management-doc?populate=*",
  essentialCare: "/api/essential-care?populate=*",
};


export const signUpApiEndpoints = {
  userExist: "/account/userexists",
  createAccount: "/account/mobilefirststep",
  verifySession: "/account/create-veriff-session",
  verifykyc: "/account/verify-kyc",
  // Saves the confirmed driving-licence address and marks the account verified.
  // Replaces /account/publishsignedcase, which went away with the BENEFIT/Wathiq
  // eKYC integration.
  verifyAddress: "/account/verify-address",
}
export const apiEndpoints = {
  signIn: "/token",
  ekeyLogin: "/ekey/ekey-login",
  getPolicies: "/policy/GetPolicies",
  profile: "/profile",
  appleWalletGenerateFileId: "/account/generatePolicyPass",
}

// Bilingual push notifications: persisted to the Notifications table and
// delivered over Firebase Cloud Messaging. The SQL row is the source of truth
// for the inbox — FCM is only the delivery channel, so a push that fails still
// shows up in `/mine`.
//
// These are the three recipient-side endpoints. Every one is a POST (including
// the read) and JWT-authenticated, with the user derived from the bearer token.
//
// Sending is NOT done from here. `/Notifications/send`, `/broadcast` and
// `/broadcast-service` belong to the admin dashboard and backend jobs — this
// portal only registers devices and reads the resulting inbox.
export const notificationsApiEndpoints = {
  // Hands the backend this device's FCM token so a targeted push can reach it,
  // and subscribes it to the broadcast + per-locale topics. Idempotent: upserts
  // on (UserId, Token), so it is safe to call on every launch. MUST be
  // re-called on a language switch or the OS tray keeps the old language.
  registerDevice: "/Notifications/register-device",
  // Drops the token row and unsubscribes both topics. Returns 200 { removed:
  // false } rather than 404 when the token was not on file.
  unregisterDevice: "/Notifications/unregister-device",
  // The signed-in user's inbox: their targeted notifications plus every
  // broadcast, newest first. Body is optional; `Take` defaults to 50, caps at 200.
  mine: "/Notifications/mine",
}

export const accountApiEndpoints = {
  // OTP
  sendToken: "/account/sendtoken",
  verifyToken: "/account/verifytoken",

  // Quick Renewal Login OTP
  sendLoginOtp: "/account/send-login-otp",
  verifyLoginOtp: "/account/verify-login-otp",

  // eKYC

  // Veriff

  // updatePhone
  changeMobileApi: "/account/updatephone",
};

export const constantsApiEndpoints = {
  cars: "/constants/cars",
  banks: "/constants/banks",
  countries: "/constants/countries",
  occupations: "/constants/occupations",
  blocksAndAreas: "/constants/blocks-and-areas"
}

export const motorApiEndpoints = {
  // MEEJ
  calculateSumInsured: "/Meej/CalculateSumInsured",
  calculatePremium: "/Meej/calculatepremium",
  coverPrices: "/Meej/CoversPrices",
  policyTransferRequest: "/Meej/policyTransferRequest",
  startPolicyTransfer: "/Meej/startpolicytransfer",
  adjustSumInsured: "/Meej/StartAdjustSumInsured",
  rejectEndorsement: "/Meej/RejectEndorsement",
  endEndorsement: "/Endorsement/EndEndorsement",



  // Motor
  getQuote: "/motor/quote",

  // GDT
  retrieveVehicleDetails: '/GDT/RetrieveVehicleDetails',
  retrievePlateTypes: '/GDT/RetrievePlateTypes',
  // Policy View
  policyView: '/policy/view',

  // Endorsements
  cancelPolicy: '/Meej/CancelActivePolicy',
  rejectCancelPolicy: '/Meej/RejectCancelPolicy',
  getQuoteWithRefund: '/Meej/GetQuoteWithRefund',
  ChangePlate: '/Endorsement/updateRegNumber',

  // view docs
  ViewDocs: '/policy/ViewIssuedQuoteDocs',

  // scan bank letter
  scanBankLetter: '/openAi/scanBankLetter',

  // remove bank
  removeBank: '/Endorsement/removeBank'

}

export const aiApiEndpoints = {
  // OpenAI
  scanOwnership: "/openAi/scanOwnership",

}

export const policyApiEndpoints = {
  // MEEJ
  pay: "/policy/pay",
  payAddCovers: "/policy/PayAddCovers",
  premium: "/policy/premium",
  motorRenewal: "/policy/motorRenewal",
  policyView: '/policy/view',
  payTransferFees: "/policy/PayTransferFees",
  payAdjustSumInsuredFees: "/policy/PayAdjustSumInsured",


  verify: "policy/verify",
  // view docs
  ViewDocs: '/policy/ViewIssuedQuoteDocs',

  // Promo code
  applyPromo: "/policy/applypromo"

}

export const filesApiEndpoints = {
  // Uploading files
  token: "/tokens/request",
  upload: "/files/upload",
  getLink: "/tokens/request",

}

export const expressShieldEndPoints = {
  createLead: "/lead/createlead",
  updateLead: "/lead/updatelead",
  expressSheildSave: "/Life/expresShield",
  checkParty: "/customer/checkparty",
  partyCreate: "/customer/new",
  payment: "/policy/pay"
}

export const essentialCareEndPoints = {
  essentialCareQuote: "/Life/EssentialHealth"
}

export const forgotPasswordApiEndpoints = {
  forgotpassword: "/account/forgotpassword",
  resetpassword: "account/resetpassword"
}

export const lifeApiEndPoints = {
  createRequests: "Life/CreateLifeRequest",
  lifePolicyDetails: "/Life/GetLifePolicyDetails",
  rollingPerformance: "/Life/rolling_performance",
  investmentEndPoints: {
    allfunds: "/Life/allfunds",
    tcsCatalog: "/Life/tcscatalog",
    singleFundDetails: "/Life/GetLifePolicyDetails",
  }
}

export const crmApiEndPoints = {
  caseComplaint: "/case/complaint",
  crmClaims: "/ClaimCrm/getclaims",
  crmClaimDetails: "/ClaimCrm/GetUserClaimDetails",
  crmCreateLead: "/lead/createlead",
}

export const changePasswordEndpoints = {
  confirmpassword: "/account/confirmpassword",
  updatepassword: "/account/updatepassword"
}
